
/**
 * 计算单个食材的能量
 * @param {*} singleRatio  单个食材的占比
 * @param {*} allRation  所有食材占比的总和
 * @param {*} singleEnergy 单个食材的能量
 * @returns 单个对应占比的能量
 * 参考公式
 * （singleRatio/allRation * 100）* (singleEnergy / 100) 约去100
 */
export const calcEnergy = (singleRatio, allRation, singleEnergy) => {
    const r1 = singleRatio && !isNaN(Number(singleRatio));
    const r2 = allRation && !isNaN(Number(allRation));
    const r3 = singleEnergy && !isNaN(Number(singleEnergy));
    if(!(r1 && r2 && r3)) {
        return '';
    }
    const result =  Number(singleRatio) / Number(allRation) * Number(singleEnergy);
    /* 四舍五入保留两位小数 */
    return Math.round((result + Number.EPSILON) * 100) / 100;
}

/* 判断是否为对象数组 */
export function isObjectArray(arr) {
    // 1. 检查是否为数组
    if (!Array.isArray(arr)) return false;
    
    // 2. 检查每个元素是否为对象（非 null）
    return arr.every(item => 
      item !== null && typeof item === 'object'
    );
  }